import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '内容导航',
    links: [
      { label: '剧情介绍', path: '/category/plot' },
      { label: '演员阵容', path: '/category/cast' },
      { label: '幕后故事', path: '/category/behind-scenes' },
      { label: '观看指南', path: '/category/watch-guide' },
      { label: '剧评分析', path: '/category/reviews' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', path: '/about' },
      { label: '口碑声誉', path: '/about' },
      { label: '联系我们', path: '/about' },
      { label: '最新资讯', path: '/category/news' },
    ],
  },
  {
    title: '观看平台',
    links: [
      { label: '腾讯视频', path: '/category/watch-guide' },
      { label: '爱奇艺', path: '/category/watch-guide' },
      { label: '优酷', path: '/category/watch-guide' },
      { label: 'B站', path: '/category/watch-guide' },
    ],
  },
];

const socialLinks = [
  { icon: 'ri-weibo-line', label: '微博', href: '#' },
  { icon: 'ri-wechat-line', label: '微信', href: '#' },
  { icon: 'ri-bilibili-line', label: 'B站', href: '#' },
  { icon: 'ri-tiktok-line', label: '抖音', href: '#' },
];

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 no-underline mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-shield-flash-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading font-bold text-xl text-background-50">
                赤裸特工
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed max-w-sm">
              赤裸特工是一部融合动作、悬疑与间谍元素的热门作品，集结顶尖卡司与烧脑剧情，带你深入特工世界的隐秘角落。
            </p>
            <div className="flex items-center gap-3 mt-6">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  rel="nofollow noopener noreferrer"
                  target="_blank"
                  aria-label={social.label}
                  className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-400 hover:bg-primary-500 hover:text-background-50 transition-all duration-200"
                >
                  <i className={`${social.icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading font-semibold text-background-50 text-sm mb-4">
                {group.title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 no-underline"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 赤裸特工官方. 保留所有权利.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200 no-underline">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200 no-underline">服务条款</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200 no-underline">Cookie 设置</a>
          </div>
        </div>
      </div>
    </footer>
  );
}